import React, { useState, useEffect, useMemo } from "react";
import styles from "./Step3Strategy.module.scss";
import StrategyCard from "../ui/StrategyCard/StrategyCard";
import Button from "../ui/Button/Button";
import InfoBox from "../ui/InfoBox/InfoBox";

// Mock data based on the spec
const mockStrategyData = [
  {
    id: "minimal",
    title: "Мінімальний захист",
    description: "Захист основної поточної діяльності.",
    classCount: 2,
    classes: [
      "Клас 30: Кава, чай, кондитерські вироби.",
      "Клас 43: Послуги кафе, ресторанів, барів.",
    ],
    isRecommended: false,
  },
  {
    id: "medium",
    title: "Середній захист",
    description: "Захист поточного бізнесу та суміжних напрямків для росту.",
    classCount: 4,
    classes: [
      "Клас 30: Кава, чай, кондитерські вироби.",
      "Клас 43: Послуги кафе, ресторанів, барів.",
      "Клас 35: Реклама, керування програмами лояльності, онлайн-продаж.",
      "Клас 21: Продаж брендованих товарів (чашки, посуд).",
    ],
    isRecommended: true,
  },
  {
    id: "maximal",
    title: "Максимальний захист",
    description:
      "Повний захист для масштабування, запуску нових продуктів та франшизи.",
    classCount: 5,
    classes: [
      "Клас 30: Кава, чай, кондитерські вироби.",
      "Клас 43: Послуги кафе, ресторанів, барів.",
      "Клас 35: Реклама, керування програмами лояльності, онлайн-продаж.",
      "Клас 21: Продаж брендованих товарів (чашки, посуд).",
      "Клас 41: Проведення майстер-класів, освітніх заходів.",
    ],
    isRecommended: false,
  },
];

const nameMapping = {
  Min: "minimal",
  Mid: "medium",
  Max: "maximal",
};

const titleMapping = {
  Min: "Мінімальний захист",
  Mid: "Середній захист",
  Max: "Максимальний захист",
};

const Step3Strategy = ({ onNextStep, analysisResult }) => {
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  const strategyData = useMemo(() => {
    return analysisResult
      ? analysisResult.map((strategy) => ({
          id: nameMapping[strategy.name],
          title: titleMapping[strategy.name],
          description: strategy.description,
          classCount: strategy.classCount,
          classes: strategy.classes.map(
            (c) => `Клас ${c.id}: ${c.description}`
          ),
          classIds: strategy.classes.map((c) => c.id),
          isRecommended: strategy.name === "Mid", // Assuming Mid is always recommended
        }))
      : mockStrategyData;
  }, [analysisResult]);

  useEffect(() => {
    if (strategyData) {
      const recommended = strategyData.find((s) => s.isRecommended);
      if (recommended) {
        setSelectedStrategy(recommended.id);
      }
    }
  }, [strategyData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.subtitle}>
          На основі опису вашої діяльності ми підготували{" "}
          <strong>три варіанти захисту бренду.</strong>
        </p>
        <InfoBox>
          Кількість классів напряму впливає на вартість послуг і державних
          зборів, чим їх більше, тим дорожче.
        </InfoBox>
      </div>

      <div className={styles.cardsContainer}>
        {strategyData.map((card) => (
          <StrategyCard
            key={card.id}
            card={card}
            isSelected={selectedStrategy === card.id}
            isRecommended={card.isRecommended}
            onSelect={setSelectedStrategy}
          />
        ))}
      </div>

      <div className={styles.buttonWrapper}>
        <Button
          variant="primary"
          onClick={() => {
            const selected = strategyData.find(
              (s) => s.id === selectedStrategy
            );
            onNextStep({
              protection_level: selectedStrategy,
              classCount: selected ? selected.classCount : 0,
              classIds: selected ? selected.classIds : [],
            });
          }}
          disabled={!selectedStrategy}
        >
          Перейти до вибору пакета послуг
        </Button>
      </div>
    </div>
  );
};

export default Step3Strategy;
